export const FeatureFlags = {
  SSO_SELF_SERVE: 'enterprise.sso_self_serve',
  NAVIGATION_REDESIGN: 'enterprise.dashboard-navigation-redesign',
  TEAM_CLAIM: 'fv.web.team-claim',
  AD_HOC_LICENSES: 'enterprise.ad-hoc-licenses',
  AD_HOC_LICENSES_BOARD_GUESTS: 'enterprise.ad-hoc-licenses-board-guests',
};
